import { Alert } from "components/commons/alert";
import { SelectPeriod } from "components/hr-metrics/happiness-index/create/SelectPeriod";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_HAPPINESS_INDEX } from "services/apiHappinessIndex";
import { useFetch } from "services/useFetch";

const SelectPeriodContainer = () => {
    const navigate = useNavigate()
    const [selectedMonth, setSelectedMonth] = useState({
        start_period: '',
        end_period: ''
    })
    const {fetching: createPeriod} = useFetch(API_HAPPINESS_INDEX.CREATE_PERIOD)

    const onChangeMonth = (key, value) => {
        setSelectedMonth({
            ...selectedMonth,
            [key]: value
        })
    }

    const onSubmit = () => {
        createPeriod(selectedMonth)
            .then(response => {
                navigate(`/human-resource-metrics/create-happiness-index/import-data?periodId=${response?.data?.id}`)
            }).catch(() => {
                setSelectedMonth({
                    start_period: '',
                    end_period: ''
                })
                Alert({
                    icon: 'error',
                    title: 'Oops!',
                    message: 'Periode yang di pilih sudah digunakan',
                })
            })
    }

    const props = {
        selectedMonth,
        onChangeMonth,
        onSubmit
    }

    return (
        <SelectPeriod {...props}/>
    )
}

export default SelectPeriodContainer
